import React, { Component } from "react";
import { withRequest } from "../../../utils/request";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import Loader from "../../general/Loader";
import AusenciasForm from "./Form";
import Modal from "../../general/Modal";

class Ausencias extends Component {
    state = {
        ausencias: [],
        showCreate: false,
        loading: true
    };
    componentDidMount() {
        this.getAusencias();
    }
    getAusencias = async (url = null) => {
        const id = this.props.empleado.id;
        url = url ? url : `empleados/${id}/ausencias`;
        const ausencias = await this.props.request(url);

        if (ausencias.success) {
            this.setState({
                ausencias: ausencias.data,
                loading: false
            });
        }
    };
    removeAusencia = async (event, ausencia) => {
        event.preventDefault();

        const { empleado } = this.props;
        const token = auth.getToken();

        const url = `empleados/${empleado.id}/ausencias/${ausencia}`;

        const res = await fetch(apiUrl(url), {
            method: "delete",
            headers: {
                Accept: "application/json",
                "X-Request-With": "XMLHttpRequest",
                Authorization: "Bearer " + token
            }
        });

        const response = await res.json();

        if (response.success) {
            this.getAusencias();
            return;
        } else {
            this.setState({ errors: response.data.message });
        }
    };
    toggleCreateModal = () => {
        this.setState({
            showCreate: !this.state.showCreate
        });
    };
    render() {
        const { empleado } = this.props;
        const { ausencias, loading } = this.state;

        if (loading === 0) {
            return <Loader />;
        }
        return (
            <div>
                <div className='row m-b-20'>
                    <div className='col'>
                        <h3>Ausencias</h3>
                    </div>
                    <div className='col text-right'>
                        <button
                            onClick={this.toggleCreateModal}
                            className='au-btn au-btn-icon au-btn--green au-btn--small'>
                            Nueva
                        </button>
                    </div>
                </div>
                <table className='table tickets-table'>
                    <thead>
                        <tr>
                            <th>Descripción</th>
                            <th>Fecha</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {ausencias.map(ausencia => (
                            <tr key={ausencia.id}>
                                <td>{ausencia.descripcion}</td>
                                <td>{ausencia.fecha}</td>
                                <td>
                                    <button
                                        onClick={event =>
                                            this.removeAusencia(
                                                event,
                                                ausencia.id
                                            )
                                        }>
                                        <i className='fa fa-trash-alt' />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Modal
                    show={this.state.showCreate}
                    blank={true}
                    toggle={this.toggleCreateModal}>
                    <AusenciasForm
                        toggle={this.toggleCreateModal}
                        empleado={empleado}
                        getAusencias={this.getAusencias}
                    />
                </Modal>
            </div>
        );
    }
}

export default withRequest(Ausencias);
